/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ValuationModel = {
    ValuationId?: string;
    AccountNumber?: string;
    AssetId?: string;
    NewValuation?: number;
    NewValuationDate?: string;
    SubmissionDate?: string;
    ValuationStatus?: ValuationModel.ValuationStatus;
    ZendeskTicketId?: number | null;
};
export namespace ValuationModel {
    export enum ValuationStatus {
        NEW = 'New',
        PENDING = 'Pending',
        RESOLVED = 'Resolved',
        SKIPPED = 'Skipped',
    }
}

